import axios from "axios";
import { createRef } from "react";
import querystring from "querystring";

export const tokenRef = createRef();
// const querystring = require("querystring");

interface Parameters {
  url: string;
  data?: any;
  responseType?: any;
  onUploadProgress?: any;
  headers?: any;
}

const sendRequest = {
  post: (params: Parameters) => handleRequest(params, "post"),
  put: (params: Parameters) => handleRequest(params, "put"),
  get: (params: Parameters) => handleRequest(params, "get"),
  delete: (params: Parameters) => handleRequest(params, "delete"),
};

export default sendRequest;

function handleRequest(params: Parameters, method: any): Promise<any> {
  console.log("---> API: ", params.url, method);
  return new Promise((resolve, reject) => {
    if (!params.url) {
      reject({ message: "URL is required for http request" });
      return;
    }

    if (params.data && ["get", "delete"].includes(method)) {
      params.url += "?" + querystring.stringify(params.data);
    }

    if (
      (method === "post" || method === "put") &&
      params.data &&
      !(params.data instanceof FormData)
    ) {
      const hasFile = Object.values(params.data).some(
        (val) =>
          val instanceof File ||
          val instanceof Blob ||
          (Array.isArray(val) && val.some((v) => v instanceof File || v instanceof Blob))
      );

      if (hasFile) {
        const formData = new FormData();
        Object.keys(params.data).forEach((key) => {
          formData.append(key, params.data[key]);
        });
        params.data = formData;
      }
    }

    const isFormData = params.data instanceof FormData;

    request
      .request({
        method,
        responseType: params.responseType,
        url: params.url,
        data: params.data,
        // config: params.config,
        onUploadProgress: params.onUploadProgress,
        headers: {
          ...params.headers,
          // FormData gönderilirken Content-Type set edilmemeli;
          // axios boundary'li multipart/form-data header'ını otomatik ekler.
          ...(isFormData ? {} : { "Content-Type": "application/json" }),
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res: any) => {
        resolve(res?.data?.data || res?.data);
      })
      .catch((err: any) => reject(err));
  });
}

const request = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

request.interceptors.response.use(
  async function (config) {
    return config;
  },
  async function (error) {
    const err = error.toJSON();
    if (err?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
    }
    return Promise.reject(error);
  }
);
